<template>
	<span :style="{ cursor: disabled ? 'not-allowed' : 'pointer' }" class="checkbox" style="margin: 5px 0;" @click.stop.prevent="onClick">
		<span class="checkbox-block">
			<svg-checkbox-filled-checked v-if="isChecked" :style="checkboxStyle" />
			<svg-checkbox v-if="!isChecked" :style="checkboxStyle" />
		</span>

		<span v-if="$slots.default" class="checkbox-text" :class="{ 'text-muted': disabled }">
			<slot />
		</span>
	</span>
</template>

<script setup lang="ts">
import { computed, ref, watch, onMounted } from "vue"
import SvgCheckboxFilledChecked from "@/svg/customer/checkbox/checkbox-filled-checked.svg"
import SvgCheckbox from "@/svg/customer/checkbox/checkbox.svg"

const props = defineProps({
	modelValue: {
		type: [Boolean, String, Number, Array],
		default: false
	},
	value: {
		type: [Boolean, String, Number],
		default: 1
	},
	disabled: {
		type: [Boolean, String, Number],
		default: false
	},
	readonly: {
		type: [Boolean, Number],
		default: false
	},
})

// Emits
const emit = defineEmits(['update:modelValue'])

// Reactives
const currentValue = ref<string | number | boolean | unknown[]>(false)

// Computeds
const isChecked = computed(() => {
	// If currentValue is array, look for a value in it
	if(Array.isArray(currentValue.value)){
		return currentValue.value.includes(props.value)
	}else{
		return !!currentValue.value
	}
})

const checkboxStyle = computed(() => {
	return {
		opacity: props.disabled ? 0.5 : 1,
		color: !isChecked.value ? '#ccc' : 'inherit'
	}
})

// Watchers
watch(() => props.modelValue, newVal => {
	currentValue.value = newVal
})

// Methods
function onClick(){
	if(props.disabled || props.readonly) return;
	
	// If currentValue is array, return an updated copy of it
	if(Array.isArray(currentValue.value)){
		if(!isChecked.value){
			currentValue.value.push(props.value)
		}else{
			var index = currentValue.value.indexOf(props.value)
			if (index !== -1) {
				currentValue.value.splice(index, 1)
			}
		}

		emit('update:modelValue', currentValue.value)
	}else{
		emit('update:modelValue', isChecked.value ? null : props.value)
	}
}

// Lifecycle
onMounted(() => {
	currentValue.value = props.modelValue
})
</script>
